import { last, size, split, startsWith, toNumber } from 'lodash';

// gets the form value as a number so that we send back a number to the API
const getAmountValue = input => {
  const value = last(split(input, '$'));
  const asNumber = toNumber(value);
  return Number.isNaN(asNumber) ? input : asNumber;
};

// checks to see if the current form value is a valid number
const amountIsValid = input => {
  const value = getAmountValue(input);

  if (!/^(\d+|\d+\.\d{1,2})$/.test(value)) {
    return false;
  }

  if (value < 10 || value > 400) {
    return false;
  }

  return true;
};

// automatically put a '$' in front of the number as we type
const autoFormatAmount = input => {
  if (!amountIsValid(input)) {
    return input;
  }

  if (input === '$') {
    return '';
  }
  if (size(input) > 0 && !startsWith(input, '$')) {
    return `$${input}`;
  }
  return input;
};

const ERROR_MESSAGES = {
  INVALID_INPUT: 'Amount must be between $10 and $400',
};

const errorMessage = amount => {
  if (!amountIsValid(amount)) {
    return ERROR_MESSAGES.INVALID_INPUT;
  }

  return undefined;
};

export { autoFormatAmount, amountIsValid, ERROR_MESSAGES, errorMessage, getAmountValue };
